// extracted by mini-css-extract-plugin
export default {"button":"button_main_button__363kJ","wiggle":"button_main_wiggle__x++kn"};